<template>
  <div class="footer">
    <div class="footer-box">
      <div class="left">
        <h1>华凤技术（南京）有限公司</h1>
        <h2>{{ companyInfo.phone }}</h2>
        <p>热线电话</p>
      </div>
      <div class="center">
        <div class="menu" v-for="(item, index) in menuList" :key="index">
          <div
            class="menu-title"
            :class="!item.menu ? 'hover' : ''"
            @click="goUrl(item)"
          >
            {{ item.name }}
          </div>
          <div
            class="menu-item"
            v-for="(item2, index2) in item.menu"
            :key="index2"
            @click="goUrl(item2)"
          >
            {{ item2.name }}
          </div>
        </div>
      </div>
      <div class="right">
        <!-- <div>
          <img src="@/assets/img/qrcode1.png" alt="" />
          <p>技术施工代理人</p>
        </div>
        <div>
          <img src="@/assets/img/qrcode2.png" alt="" />
          <p>项目开发代理人</p>
        </div> -->
        <div>
          <img src="@/assets/img/华凤云小程序码.jpg" alt="" />
          <p>华凤云小程序</p>
        </div>
        <div>
          <img src="@/assets/img/qrcode.jpg" alt="" />
          <p>官方微信公众号</p>
        </div>
      </div>
    </div>
    <div class="footer_bottom">
      <div class="left">
        Copyright © 2006-2024 HuaFeng All Rights Reserved.
        <span>苏ICP备2024058247号-2</span>
        <img src="@/assets/img/police.png" alt="" />
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32011402012126" rel="noreferrer" target="_blank">苏公网安备32011402012126号</a>
      </div>
      <div class="right">
        <div class="imgbox" @click="goIndex()"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      companyInfo: JSON.parse(sessionStorage.getItem("companyInfo")) || {},
      companyList: JSON.parse(sessionStorage.getItem("companyList")) || [],
      // menuList: [
      //   {
      //     name: "企业优势",
      //     menu: [
      //       {
      //         name: "业务优势",
      //         path: "/businessAdvantages",
      //       },
      //       {
      //         name: "综合优势",
      //         path: "/comprehensiveAdvantages",
      //       },
      //     ],
      //   },
      //   {
      //     name: "项目案例",
      //     menu: [
      //       {
      //         name: "预建设",
      //         path: "/preConstruction",
      //       },
      //     ],
      //   },
      //   {
      //     name: "公司新闻",
      //     // path: "/companyNews",
      //     menu: [
      //       {
      //         name: "公司新闻",
      //         path: "/companyNews",
      //       },
      //     ],
      //   },
      //   {
      //     name: "了解更多",
      //     menu: [
      //       {
      //         name: "关于我们",
      //         path: "/aboutUs",
      //       },
      //       {
      //         name: "加入我们",
      //         path: "/joinUs",
      //       },
      //       {
      //         name: "代理合作",
      //         path: "/agentCooperation",
      //       },
      //       {
      //         name: "数字画册",
      //         url: "https://flbook.com.cn/c/FPafNHcLpl",
      //       },
      //     ],
      //   },
      //   {
      //     name: "内部管理",
      //     menu: [
      //       {
      //         name: "网站管理",
      //         url: "/officialWeb_web",
      //       },
      //     ],
      //   },
      // ],
      menuList: []
    };
  },
  mounted() {
    this.getMenuData();
    this.$nextTick(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
          }
        });
      });

      document.querySelectorAll(".animate-up").forEach((element) => {
        observer.observe(element);
      });
    });
  },
  methods: {

     // 获取底部菜单数据
     getMenuData() {
      this.$api.selectMenu({type:1}).then((res) => {
        if (res && Array.isArray(res)) {
          console.log("底部菜单数据:", res);
          
          // 处理接口返回的菜单数据
          this.menuList = res.map(item => {
            const menuItem = {
              name: item.menuName,
              menu: []
            };
            
            // 如果有子菜单
            if (item.hasChildren && item.children && item.children.length > 0) {
              menuItem.menu = item.children.map(child => {
                const subItem = {
                  name: child.menuName
                };
                
                // 根据type设置不同的跳转方式
                switch (child.type) {
                  case "0": // 链接
                    subItem.url = child.menuAdd;
                    break;
                  case "1": // 路由
                  case "4": // 一级菜单
                    subItem.path = child.menuAdd;
                    break;
                  case "2": // iframe
                  case "3": // 图片
                    subItem.url = child.menuAdd;
                    break;
                  default:
                    subItem.path = child.menuAdd;
                }
                
                return subItem;
              });
            } else {
              // 如果没有子菜单，根据类型设置跳转方式
              if (item.type === "0") {
                menuItem.url = item.menuAdd;
              } else {
                menuItem.path = item.menuAdd;
              }
            }
            
            return menuItem;
          }).filter(item => item.name !== "首页"); // 过滤掉首页选项
          
          console.log("底部菜单数据已更新:", this.menuList);
        }
      }).catch(error => {
        console.error("获取底部菜单数据失败:", error);
      });
    },
    
    goIndex() {
      if (this.$route.path != "/" && this.$route.path !== "index") {
        this.$router.push({ path: "/" });
      }
    },
    goUrl(item) {
      if (item.path) {
        if (this.$route.path !== item.path) {
          this.$router.push({ path: item.path });
        } else {
          window.location.reload();
        }
      } else if (item.url) {
        window.open(item.url, "_blank");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  display: block;
  width: calc(100vw - 320px);
  margin: auto;
  background: #111214;
  letter-spacing: normal;
  position: relative;
  left: -160px;
  padding: 0 160px;
  .footer-box {
    display: flex;
    flex-wrap: nowrap;
    padding: 70px 0;
    .left {
      border-right: 1px solid #666;
      padding: 0 60px 0 0;
      h1 {
        font-size: 30px;
        font-weight: 700;
        line-height: 30px;
        margin: 0 0 90px;
      }
      h2 {
        font-size: 28px;
        font-weight: 400;
        line-height: 28px;
        margin: 0 0 16px;
      }
      p {
        font-size: 14px;
        line-height: 14px;
        font-weight: 400;
        letter-spacing: normal;
      }
    }
    .center {
      flex: 1;
      width: 0;
      padding: 0 0 0 30px;
      display: flex;
      flex-wrap: nowrap;

      .menu {
        margin: 0 80px 0 0;
        .menu-title {
          font-size: 18px;
          font-weight: 400;
          line-height: 22px;
          white-space: nowrap;
          margin: 0 0 32px;
        }
        .menu-item {
          cursor: pointer;
          font-size: 14px;
          line-height: 16px;
          margin: 0 0 24px;
          color: #999;
          letter-spacing: normal;
          white-space: nowrap;
          &:hover {
            color: #009ade;
          }
          &:last-child {
            margin: 0;
          }
        }
        .hover {
          cursor: pointer;
          &:hover {
            color: #009ade;
          }
        }
      }
    }
    .right {
      text-align: center;
      display: flex;
      flex-wrap: nowrap;
      div {
        margin: 0 0 0 16px;
      }
      img {
        display: block;
        width: 96px;
        height: 96px;
        margin: auto;
      }
      p {
        font-size: 14px;
        line-height: 14px;
        margin: 20px 0 0;
        font-weight: normal;
        letter-spacing: normal;
      }
    }
  }
  .footer_bottom {
    border-top: 1px solid #666;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    height: 61px;
    align-items: center;
    .left {
      color: #999;
      font-size: 14px;
      line-height: 14px;
      display: flex;
      align-items: center;
      span {
        // cursor: pointer;
        margin: 0 0 0 12px;
      }
      img {
        width: 18px;
        height: 20px;
        margin: 0 4px 0 24px;
      }

      a{
        color: #999;
      }
    }
    .right {
      .imgbox {
        width: 83px;
        height: 30px;
        cursor: pointer;
        background-image: url("~@/assets/img/logo2.png");
        background-size: cover;
        &:hover {
          background-image: url("~@/assets/img/logo3.png");
        }
      }
    }
  }
}
</style>
